import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectPbmSelectValue = createSelector([selectComposedReportState], ({ pbms }) => pbms)
